module.exports = __webpack_public_path__ + "static/img/office_6.bcb76d59.jpg";